export default __webpack_public_path__ + "static/media/blue-background.8c77d564.jpg";